import { Box, BoxProps, Button, Typography } from '@material-ui/core';
import { theme } from '../../theme';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchExternalLink } from './externalLinkSlice';
import { useEffect } from 'react';

const ExtraLink = ({ sx }: { sx?: BoxProps['sx'] }) => {
  const dispatch = useAppDispatch();
  const { externalLink, externalLinkTitle, externalLinkDescription } =
    useAppSelector((state) => state?.externalLink);
  const cxCouponIssued = useAppSelector((state) => {
    return state?.inputAnswer?.session?.cxHttpRes?.data?.cxCouponIssued;
  });

  useEffect(() => {
    dispatch(
      fetchExternalLink({ couponToken: cxCouponIssued?.couponToken || null }),
    );
  }, [dispatch, cxCouponIssued?.couponToken]);

  if (!externalLink || !externalLinkTitle || !externalLinkDescription) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: !!cxCouponIssued?.cxCoupon ? 'column' : 'column-reverse',
        ...sx,
      }}
    >
      <Button
        variant="contained"
        color="primary"
        style={{
          width: '300px',
          border: `1px solid ${theme.palette.primary.contrastText}`,
        }}
        component="a"
        href={externalLink}
        target="_blank"
        rel="noopener"
      >
        <Typography
          variant="body1"
          style={{ fontWeight: '600', textAlign: 'center', color: '#000000DE' }}
        >
          {externalLinkTitle}
        </Typography>
      </Button>

      <Box m={1} />
      <Typography
        variant="h6"
        style={{
          wordBreak: 'break-word',
          width: '100%',
          fontWeight: '700',
          whiteSpace: 'pre-wrap',
        }}
      >
        <Box>{externalLinkDescription}</Box>
      </Typography>
    </Box>
  );
};

export default ExtraLink;
